/**
 * Avatar do chat: foto do perfil do WhatsApp quando existe; senão iniciais (mesmo desenho do
 * `Avatar` da Plataforma). A foto vem de uma URL externa do WhatsApp: se falhar ao carregar,
 * a imagem some e ficam as iniciais, nunca um ícone quebrado.
 */
import React, { useState, type ReactElement } from "react";
import { Users } from "lucide-react";
import { initialsOf } from "../../ui/index.js";

const SIZES = { sm: "h-7 w-7 text-[11px]", md: "h-9 w-9 text-xs", lg: "h-16 w-16 text-xl" } as const;

export function ChatAvatar({ name, pictureUrl, size = "md", group = false }: { name: string; pictureUrl?: string | null; size?: keyof typeof SIZES; group?: boolean }): ReactElement {
  const [failed, setFailed] = useState(false);
  const box = `grid shrink-0 place-items-center overflow-hidden rounded-pill font-extrabold ${SIZES[size]}`;
  if (pictureUrl && !failed) {
    return (
      <span className={box + " bg-surface-soft"} aria-hidden>
        <img src={pictureUrl} alt="" loading="lazy" referrerPolicy="no-referrer" className="h-full w-full object-cover" onError={() => setFailed(true)} />
      </span>
    );
  }
  return (
    <span className={box + (group ? " bg-info-soft text-info" : " bg-brand-wash text-brand-text")} aria-hidden>
      {group ? <Users className="h-1/2 w-1/2" focusable={false} /> : initialsOf(name)}
    </span>
  );
}
